import { memo, VFC, useState, useEffect, useCallback, useRef } from 'react';
import {
  Table,Tbody,Tr,Th,Td,Text,
  Spinner,Center,Box,
  Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,ModalFooter,
  useDisclosure,Flex,Spacer,
} from '@chakra-ui/react';
import { DownloadIcon, DeleteIcon } from '@chakra-ui/icons';
import { PrimaryButton } from '../atoms/button/PrimaryButton';
import { ListButton } from '../atoms/button/ListButton';
import { MultiXSText } from '../atoms/text/MyText';
import { useIssue } from '../../hooks/useIssue';
import { ErrorDialog } from "../../components/organisms/modal/ErrorDialog";
import { UpdateIssueGroupDialog } from "../../components/organisms/modal/UpdateIssueGroupDialog";
import { CompleteDialog } from "../../components/organisms/modal/CompleteDialog";
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { GV_DESKADMINS } from '../../hooks/useConst';
import { useOpelog } from '../../hooks/useOpelog';
import { getIssueGroupResult, attachObj } from '../../types/issue'

const headerDetail = {
  groupName: '障害グループ名',
  region: 'クラウド種別／障害リージョン／サービス',
  failTerm: '障害発生期間(JST)',
  comment: '事務局コメント',
  awsReport: '報告書',
  inquiry: '問い合わせ件数',
  summary: '要約',
};

type Props = {
  loading: boolean;
  getIssueGroupResult:getIssueGroupResult;
  setExecFlag: (flag:boolean)=>void;
};

export const IssueGroupDetail: VFC<Props> = memo((props) => {
  const { getIssueGroupResult, setExecFlag } = props;
  const { loginUser } = useLoginUser();
  const [ groupName ] = useState(getIssueGroupResult?.group_name ?? "");
  const [ groupId ]   = useState(getIssueGroupResult?.group_id ?? "");
  const [ regions, setRegions ]       = useState<Array<string>>([]);
  const [ startTime, setStartTime ]   = useState("");
  const [ endTime, setEndTime ]       = useState("");
  const [ failTerm, setFailTerm ]     = useState("");
  const [ comment, setComment ]       = useState("");
  const [ anotherName, setAnotherName ]   = useState("");
  const [ attachList, setAttachList ] = useState<Array<attachObj>>([]);
  const [ caseListNum, setCaseListNum ] = useState(0);
  const [ updateItem, setUpdateItem ]   = useState("");
  const [ stateColor, setStateColor ]   = useState("black");
  const appType = process.env.REACT_APP_APP_TYPE;
  // const openState = "継続中";

  useEffect(() => {
    if( getIssueGroupResult ){
      setRegions(getIssueGroupResult.region_name ? getIssueGroupResult.region_name.split(',') : []);
      setStartTime(getIssueGroupResult.start_time ?? "");
      setEndTime(getIssueGroupResult.end_time ?? "");
      setFailTerm(getIssueGroupResult.fail_term ?? "");
      setComment(getIssueGroupResult.comment ?? "");
      setAttachList(getIssueGroupResult.attach_list);
      setAnotherName(getIssueGroupResult.another_name)
      setCaseListNum(getIssueGroupResult.case_list.length);
      setStateColor(getIssueGroupResult.fail_term.includes('継続中') ? 'red' : 'black');
    }
  }, [getIssueGroupResult]);
  
  return (
    <>
    <Box m="10px">
    <Table id="detail-outline" colorScheme="gray" variant="striped" size="sm" align="center">
      <Tbody>
        <Tr id="group_name">
          <Th backgroundColor="#aaaaaa" color="white">
            {headerDetail.groupName}
          </Th>
          <Td>
            {anotherName ? (
              <Text fontSize="sm" color={stateColor}>{anotherName}</Text>
            ) : (
              <Text fontSize="sm" color={stateColor}>{groupName}</Text>
            )}
          </Td>
          {GV_DESKADMINS.includes(loginUser.userGroup) &&
            <Td isNumeric>
              <ListButton id='groupName' onClick={()=>setUpdateItem('anotherName')}>更新</ListButton>
            </Td>
          }
        </Tr>
        <Tr id="region-name">
          <Th backgroundColor="#aaaaaa" color="white" >
            {headerDetail.region}
          </Th>
          <Td colSpan={2}>
            {regions.map((region:string,index) => (
              <Text  key={index} fontSize="sm" color={stateColor}>{region}</Text>
            ))}
          </Td>
        </Tr>
        <Tr id="fail-term">
          <Th backgroundColor="#aaaaaa" color="white" >
            {headerDetail.failTerm}
          </Th>
          <Td colSpan={2}>
            { !failTerm ? (
              <Text></Text>
            ) : endTime ? (
              <Text fontSize="sm" color={stateColor}>{`${startTime} ～ ${endTime}`+'　'+`（対応期限）［現在までの${failTerm}］`}</Text>
            ) : !endTime ? (
              <Text fontSize="sm" color={stateColor}>{`${startTime} ～ ${endTime}`+'　'+`［${failTerm}］`}</Text>
            ) : (
              <Text fontSize="sm" color={stateColor}>{`${startTime} ～ ${endTime}`+'　'+`［${failTerm}］`}</Text>
            )}
          </Td>
        </Tr>
        {(appType === 'ADMIN' || comment) && (
          <Tr id="comment">
            <Th backgroundColor="#aaaaaa" color="white" >
              {headerDetail.comment}
            </Th>
            <Td whiteSpace="pre-line">
              <Text fontSize="sm">{comment}</Text>
            </Td>
            {GV_DESKADMINS.includes(loginUser.userGroup) &&
              <Td isNumeric>
                <ListButton id='comment' onClick={()=>setUpdateItem('comment')}>更新</ListButton>
              </Td>
            }
          </Tr>
        )}
        {(appType === 'ADMIN' || attachList.length > 0) && (
          <Tr id="aws-report">
            <Th backgroundColor="#aaaaaa" color="white" >
              {headerDetail.awsReport}
            </Th>
            <Td colSpan={2}>
              <AttachFilePart groupName={groupName} groupId={groupId} attachList={attachList} setExecFlag={setExecFlag} />
            </Td>
          </Tr>
        )}
        <Tr id="summary">
          <Th backgroundColor="#aaaaaa" color="white" >
            {headerDetail.summary}
          </Th>
          <Td colSpan={2} w="80%">
            <ShowGroupSummay getIssueGroupResult={getIssueGroupResult} />
          </Td>
        </Tr>
        {loginUser.necFlag &&
          <Tr id="inquiry">
            <Th backgroundColor="#aaaaaa" color="white" >
              {headerDetail.inquiry}
            </Th>
            <Td colSpan={2}>
              <Text fontSize="sm">{caseListNum}件</Text>
            </Td>
          </Tr>
        }
      </Tbody>
    </Table>
    </Box>
    {updateItem === 'anotherName' && (
      <UpdateIssueGroupDialog
        groupName={groupName}
        groupId={groupId}
        updateItem={updateItem}
        updateItemName={headerDetail.groupName}
        setUpdateItem={setUpdateItem}
        value={anotherName ? anotherName : groupName}
        setValue={setAnotherName} />
    )}
    {updateItem === 'comment' && (
      <UpdateIssueGroupDialog
        groupName={groupName}
        groupId={groupId}
        updateItem={updateItem}
        updateItemName={headerDetail.comment}
        setUpdateItem={setUpdateItem}
        value={comment}
        setValue={setComment} />
    )}
    </>
  );
});


/////////////////////////////////////////////////////////////
// 添付ファイルのメンテナンス
/////////////////////////////////////////////////////////////
type Props2 = {
  groupName: string;
  groupId: string;
  attachList: attachObj[];
  setExecFlag: (flag:boolean)=>void;
};

export const AttachFilePart: VFC<Props2> = (props) => {
  const { groupName, groupId, attachList, setExecFlag } = props;
  const { loginUser } = useLoginUser();
  const { DownloadReport, DeleteReport, UploadReport, result, setResult, executing, errObj } = useIssue();
  const [ procStr, setProcStr ]     = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { OutputOpelog } = useOpelog();
  const [ closeFlag, setCloseFlag ] = useState(false);
  const [ deletePath, setDeletePath ] = useState("");
  
  useEffect(() => {
    !isOpen && onOpen();
  }, []);

  // ダウンロードリンククリック
  const onClickReportLink = useCallback((temp_path: string, s3_path: string, file_name: string)=>{
    setProcStr('ダウンロード');
    DownloadReport(temp_path ? temp_path : s3_path, file_name);
    OutputOpelog('issue_summary', 'report_download', "GROUP_NAME#" + groupName);
  },[loginUser]);

  // 削除リンククリック
  const onClickDeleteButton = useCallback((s3_path: string)=>{
    setProcStr('削除');
    setDeletePath('');
    DeleteReport(s3_path,groupName,groupId);
  },[groupName,groupId]);
    
  // アップロードボタンクリック
  const onClickUploadButton = async () => {
    // file取得
    try {
      const [fileHandle] = await (window).showOpenFilePicker({ multiple: true });
      
      const file = await fileHandle.getFile();
      // file名取得
      const fileName: string = file.name;
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        // バイナリデータにエンコード
        const base64 = fileReader.result as string;
        // 先頭の余分な文字列を削除
        const fileContext = base64.replace(/data:.*\/.*;base64,/, '');
  
        // API実行
        setProcStr('アップロード');
        UploadReport(groupName, groupId, fileName, fileContext);
        OutputOpelog( 'issue_summary', 'report_upload', "GROUP_NAME#" + groupName);
      };
      
    } catch (e) {
      console.log('ファイル選択なし');
    }
  };
  
  useEffect(() => {
    if( result === 'succeed' ){
      console.log(attachList);
    }
  },[]);
  
  return (
    <>
    {errObj && !closeFlag ? (
      <ErrorDialog errTitle="障害グループ情報取得失敗" errObj={errObj} opeErrMes='' setCloseFlag={setCloseFlag} />
      
    ) : executing ? (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        motionPreset="slideInBottom"
        autoFocus={false}
        size="2xl"
        isCentered
        allowPinchZoom
      >
        <ModalOverlay />
        <ModalContent pb={2}>
          <ModalHeader>{`${procStr}中`}</ModalHeader>
          <ModalCloseButton />
          <ModalBody mx={6}>
            <Center>
              <br /><br />
              <Text>しばらくお待ちください</Text>
              <Spinner color="teal.500" />
              <br /><br /><br />
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    
    ) : deletePath ? (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        motionPreset="slideInBottom"
        autoFocus={false}
        size="xl"
        isCentered
        allowPinchZoom
      >
        <ModalOverlay />
        <ModalContent pb={2}>
          <ModalHeader>報告書の削除確認</ModalHeader>
          <ModalCloseButton />
          <ModalBody mx={6}>
            <Center>
              <br /><br />
              <Text>報告書を削除しますが、よろしいでしょうか？</Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <PrimaryButton type='ng' onClick={()=>setDeletePath("")}>キャンセル</PrimaryButton>
            {'　'}
            <PrimaryButton type='ok' onClick={()=>onClickDeleteButton(deletePath)}>削除実行</PrimaryButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      
    ) : result ? (
      <CompleteDialog
        title={`${procStr}完了`}
        onExec={result === 'download' ? ()=>setResult('') : ()=>setExecFlag(true)}
        execStr='閉じる'
        size="xl"
      >
        <Box>
          <Text align="center" fontSize="xl" color="red">{`${procStr}が完了しました。`}</Text>
        </Box>
      </CompleteDialog>
      
    ) : (
      <>
      {attachList.map((item:attachObj,index) => (
        <Flex key={index}>
          <Text>{item.file_name}</Text>
          <Text>{'　['}</Text>
          <DownloadIcon id={'file'+index} color="green.400" w={4} h={4}
            onClick={()=>onClickReportLink(
              item.temp_path,
              item.s3_path,
              item.file_name)}
          />
          <Text>{']'}</Text>
          {GV_DESKADMINS.includes(loginUser.userGroup) && (
            <>
            <Text>{'　['}</Text>
            <DeleteIcon id={item.s3_path} onClick={()=>setDeletePath(item.s3_path)} />
            <Text>{']'}</Text>
            </>
          )}
        </Flex>
      ))}
      {GV_DESKADMINS.includes(loginUser.userGroup) && (
        <Flex alignItems="center">
          <Spacer />
          <Text color="tomato" marginRight="5px">全ユーザに公開可能なファイルのみ追加してください</Text>
          <ListButton id='upload' onClick={onClickUploadButton} isLoading={executing}>{'追加'}</ListButton>
        </Flex>
      )}
      </>
    )}
    </>
  );
};

/////////////////////////////////////////////////////////////
// グループの要約
/////////////////////////////////////////////////////////////
type Props3 = {
  getIssueGroupResult: getIssueGroupResult;
};

export const ShowGroupSummay: VFC<Props3> = (props) => {
  const { getIssueGroupResult } = props;
  const { getIssueGroupSummary, issueGroupSummary, executing, errObj } = useIssue();
  const [ gs, setGS ] = useState(getIssueGroupResult.group_summary);
  const execFlag = useRef(false);
  
  // 要約がない場合は自動取得
  useEffect(() => {
    if( getIssueGroupResult.group_summary === null && !execFlag.current ){
      getGroupSummaryFunc();
      execFlag.current = true;
    }
  },[getIssueGroupResult,execFlag]);
  
 // グループサマリ取得
  const getGroupSummaryFunc = useCallback(()=>{
    getIssueGroupSummary(getIssueGroupResult.group_name_org);
  },[getIssueGroupResult]);
  
  useEffect(() => {
    if( issueGroupSummary ){
      setGS(issueGroupSummary);
      getIssueGroupResult.group_summary = issueGroupSummary;
    }
  },[issueGroupSummary]);
  
  // タイムアウトエラー504時は再実行
  useEffect(() => {
    if( !errObj ) return;
    // eslint-disable-next-line
    const errObjTmp:any = errObj; // どうしてもうまくいかないので一度tmpにとってany宣言
    if( errObjTmp.response && errObjTmp.response.status === 504 ){
      getGroupSummaryFunc();
      execFlag.current = true;
    }    
  },[errObj]);
  
  return (
    <>
    {executing ? (
      <Flex align="center">
        要約作成中。。。<Spinner color="teal.500" marginRight="5px" />
      </Flex>
    ) : errObj !== null ? (
      <>
        <Text fontSize="xs" color="tomato">要約に失敗しました。<br />連続して失敗する場合、時間を空けてから再実行してください。</Text>
        <ListButton id='summary' onClick={()=>getGroupSummaryFunc()}>要約実行</ListButton>
      </>
    ) : issueGroupSummary === '' && getIssueGroupResult.group_summary === null ? (
      <ListButton id='summary' onClick={()=>getGroupSummaryFunc()}>要約実行</ListButton>
    ) : gs && (
      <>
        <MultiXSText str={gs} size="sm" />
        <Text fontSize="xs" color="darkgreen" marginTop="15px">※要約はAmazon Bedrockを用いて生成しております。より正確な内容は障害毎の詳細をご確認ください。</Text>
      </>
    )}
    </>
  );
};